import { api } from '../api/client';

const authService = {
  signup: async (data) => {
    try {
      const response = await api.post('/auth/signup', 
        new URLSearchParams({
          name: data.name,
          phone: data.phone,
          password: data.password,
          gender: data.gender
        }),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      );
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error?.message || 'Signup failed'
      };
    }
  },

  login: async (phone, password) => {
    try {
      const response = await api.post('/auth/login', 
        new URLSearchParams({
          phone: phone,
          password: password
        }),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      );
      
      if (response.data.token) {
        localStorage.setItem('journi_token', response.data.token);
        localStorage.setItem('journi_user', JSON.stringify(response.data.user));
      }
      
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error?.message || 'Login failed'
      };
    }
  },

  sendOTP: async (phone) => {
    try {
      const response = await api.post('/auth/send-otp', 
        new URLSearchParams({ phone: phone }),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      );
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error?.message || 'Failed to send OTP'
      };
    }
  },

  verifyOTP: async (phone, otp) => {
    try {
      const response = await api.post('/auth/verify-otp', 
        new URLSearchParams({
          phone: phone,
          otp: otp
        }),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      );
      
      if (response.data.token) {
        localStorage.setItem('journi_token', response.data.token);
        localStorage.setItem('journi_user', JSON.stringify(response.data.user));
      }
      
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error?.message || 'Invalid OTP'
      };
    }
  },

  logout: () => {
    localStorage.removeItem('journi_token');
    localStorage.removeItem('journi_user');
    window.location.href = '/login';
  },

  getCurrentUser: () => {
    const user = localStorage.getItem('journi_user');
    return user ? JSON.parse(user) : null;
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('journi_token');
  }
};

export default authService;